module.exports = __webpack_public_path__ + "media/images/homes/OrderStock-5ab45abf9a38ca19723bbf0c1ebd4633.png";